// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1qaQh","content":"Consent_content__o0VwG","footer":"Consent_footer__3OLVu"};